module.exports = __webpack_public_path__ + "assets/img/00139.13bc025f.png";